import React, { useState } from "react";
import './index.css'
import { useDispatch } from "react-redux";
import { selectTournament } from "../../../../../../redux/actions/tournaments";
import { IoMdArrowDropdown, IoMdArrowDropup  } from "react-icons/io";
import { setSelectTournament } from "./utils/tournament";
import { selectTeamFromTournament } from "../../../../../../redux/actions/teams";
import { secureUrl } from "../../../../../../utils/sortArray/secureUrl";


const TournamentsSelector = ({tournaments})=>{
    const [showListTournaments, setShowListTournaments] = useState(false)
    const dispatch = useDispatch();

    const handleSelectTournament = (tournament)=>{
        dispatch(selectTeamFromTournament(null))
        dispatch(selectTournament(tournament))
        setShowListTournaments(!showListTournaments)
        setSelectTournament(tournament)

    }

    const renderListTournaments = ()=>{
        if(!showListTournaments) return null
        return tournaments?.map(tournament => (
            <div className="container-tournament-list-item"
                onClick={()=>handleSelectTournament(tournament)}
            >
                <img src={secureUrl(tournament?.imgPicture)} style={{height:'25px', width:'25px'}} />
                <p>{tournament?.name}</p>
            </div>
        ))
    }
    const renderIconDown = ()=>{
        if(showListTournaments) return <IoMdArrowDropup size={25} /> 
        return <IoMdArrowDropdown size={25} />
    }
    return(
        <div className="container-selector-tournaments"  >
            <div className="conatiner-selector-tournaments-button" 
            onClick={()=> setShowListTournaments(!showListTournaments)}>
                <p>Torneos</p>
                {renderIconDown()}
                
            </div>
            <div className="container-selector-tournament-list" >
                { renderListTournaments()}
            </div>

        </div>
    )
}

export default TournamentsSelector